import Vue from 'vue'

// Components

// Importing Core layout component
import Toolbar from './core/Toolbar.vue'
import Drawer from './core/Drawer.vue'
import View from './core/View.vue'
import Footer from './core/Footer.vue'

// Importing Custom Components
import HelloWorld from './material/HelloWorld.vue'
import Chartist from './material/ChartCard.vue'
import OwlCarousel from './material/OwlCard.vue'

// Registered  core Components
Vue.component('core-toolbar', Toolbar)
Vue.component('core-drawer', Drawer)
Vue.component('core-view', View)
Vue.component('core-footer', Footer)

// Registered Components
Vue.component('hello-world', HelloWorld)
Vue.component('chartist-card', Chartist)
Vue.component('owl-carousel', OwlCarousel)

export {

  // core part
  Toolbar,
  Drawer,
  View,
  Footer,

  // others
  HelloWorld,
  Chartist,
  OwlCarousel
}
